import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { ArrowUpRight, LockKeyhole, Mail, Menu, X } from "lucide-react";
import { Brand } from "./Brand";
import { useContent } from "../context/ContentContext";

const navigation = [
  { label: "Aktuelles", to: "/aktuelles" },
  { label: "Mannschaften", to: "/mannschaften" },
  { label: "Training", to: "/training" },
  { label: "Verein", to: "/verein" },
  { label: "Kontakt", to: "/kontakt" },
];

export function PublicLayout() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { content } = useContent();
  const onHome = location.pathname === "/";

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="site-shell">
      <header className={`site-header ${scrolled ? "site-header--scrolled" : ""} ${onHome ? "site-header--home" : ""}`}>
        <div className="nav-wrap">
          <Brand />
          <nav className={`main-nav ${open ? "main-nav--open" : ""}`} aria-label="Hauptnavigation">
            {navigation.map((item) => (
              <NavLink key={item.to} to={item.to} className={({ isActive }) => (isActive ? "active" : "")}>
                {item.label}
              </NavLink>
            ))}
            <Link className="nav-cta" to="/downloads">
              Mitglied werden <ArrowUpRight size={16} />
            </Link>
          </nav>
          <button className="menu-toggle" onClick={() => setOpen((value) => !value)} aria-label="Menü öffnen" aria-expanded={open}>
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <Brand />
            <p>Zusammen spielen, zusammenhalten – unsere Tischtennis-Familie in Rehlingen.</p>
          </div>
          <div>
            <span className="footer-label">Verein</span>
            <Link to="/verein">Über uns</Link>
            <Link to="/mannschaften">Mannschaften</Link>
            <Link to="/training">Trainingszeiten</Link>
            <Link to="/downloads">Downloads</Link>
          </div>
          <div>
            <span className="footer-label">Kontakt</span>
            <a href={`mailto:${content.contact.email}`}><Mail size={15} /> {content.contact.email}</a>
            <span>{content.contact.address}</span>
          </div>
          <div>
            <span className="footer-label">Service</span>
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
            <Link to="/admin"><LockKeyhole size={15} /> Admin-Login</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} TTC Rehlingen 1964 e.V.</span>
          <span>Mit Herz für den Tischtennissport.</span>
        </div>
      </footer>
    </div>
  );
}
